var map = {
	"./a.png": 5213,
	"./address_image.svg": 3906,
	"./animated_ashutosha.png": 6916,
	"./animated_logo.svg": 9083,
	"./apple_logo.jpg": 4924,
	"./berkeley_logo_golden_dark.png": 9716,
	"./blogs_image.svg": 7245,
	"./cloud_infrastructure.svg": 883,
	"./codeInLogo.png": 7873,
	"./contactMail.png": 3189,
	"./coursera_logo.png": 1170,
	"./data_science.svg": 8699,
	"./deeplearning_ai_logo.png": 9575,
	"./delhivery_logo.png": 2582,
	"./developerActivity.svg": 9257,
	"./dsc_logo.png": 8750,
	"./education.svg": 1118,
	"./experience.svg": 7480,
	"./feelingProud.svg": 8294,
	"./freecopy_logo.png": 4633,
	"./fullstack.svg": 5137,
	"./gcp_logo.png": 1525,
	"./github_logo.png": 8017,
	"./googleAssistant.jpg": 1659,
	"./googleAssistant.svg": 7291,
	"./google_logo.png": 9389,
	"./ibm_logo.png": 262,
	"./iiitk_logo.png": 6200,
	"./image.png": 279,
	"./intel_logo.jpg": 8504,
	"./jis_logo.jpeg": 8603,
	"./jis_logo_2.png": 3317,
	"./jis_logo_3.png": 1692,
	"./jsFramework.svg": 9655,
	"./legato_logo.png": 1236,
	"./manOnTable.svg": 7473,
	"./microsoft_logo.png": 752,
	"./mozilla_logo.png": 6816,
	"./muffito_logo.png": 9556,
	"./nextuLogo.jpg": 8497,
	"./nptel_logo.png": 7439,
	"./nyu_logo_dark.png": 9605,
	"./nyu_side.jpeg": 6205,
	"./portfolio.gif": 8467,
	"./programmer.svg": 4700,
	"./projects_image.svg": 1240,
	"./pwa.png": 9180,
	"./saayaHealthLogo.png": 4176,
	"./stanford_logo.png": 6691,
	"./talksCardBack.svg": 6654,
	"./talksCardBackAlt.svg": 3291,
	"./ui_ux_design.svg": 9163,
	"./visualComputingProjects_images/computerVision/computerVisionProject5_Old.png": 721,
	"./visualComputingProjects_images/computerVision/diffusionAnagrams.png": 6489,
	"./visualComputingProjects_images/computerVision/facialKeypoints.png": 378,
	"./visualComputingProjects_images/computerVision/featureMatchingPanoramas.png": 929,
	"./visualComputingProjects_images/computerVision/morphFaceGif.gif": 9594,
	"./visualComputingProjects_images/computerVision/multiresolutionBlending.png": 9116,
	"./visualComputingProjects_images/computerVision/train.png": 4216,
	"./visualComputingProjects_images/geometricProcessing/3dMeshEnergyBasedDeformation.gif": 8601,
	"./visualComputingProjects_images/geometricProcessing/MLS_PointsToMesh.gif": 8426,
	"./visualComputingProjects_images/geometricProcessing/cageBasedDeformation.gif": 8079,
	"./visualComputingProjects_images/geometricProcessing/vectorFieldReconstruction.gif": 6881,
	"./visualComputingProjects_images/graphics/3dOpticalBenchSim.gif": 3717,
	"./visualComputingProjects_images/graphics/bezierForFonts.gif": 8039,
	"./visualComputingProjects_images/graphics/bezierForFontsOld2.gif": 8832,
	"./visualComputingProjects_images/graphics/clothSim.gif": 9610,
	"./visualComputingProjects_images/graphics/globalIllumination.gif": 5375,
	"./visualComputingProjects_images/graphics/loopSubdivision.gif": 8192,
	"./visualComputingProjects_images/graphics/metalPathTracer.gif": 2694,
	"./visualComputingProjects_images/graphics/rasterization.png": 9672,
	"./visualComputingProjects_images/graphics/webglRayMarchingSpheres.gif": 6701,
	"./webxr.png": 5596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9420;